import { socialLinks } from "../../utils/websiteData";

const HeaderSocialLinks = () => {
  return (
    <div className="header-socials">
      {socialLinks.map((link) => {
        return (
          <a
            key={link.id}
            href={link.url}
            target="_blank"
            rel="noreferrer noopener"
          >
            {link.icon}
          </a>
        );
      })}
    </div>
  );
};
export default HeaderSocialLinks;
